"use client";

import { c as _c } from "react/compiler-runtime";
import dynamic from "next/dynamic";
import { useState, useRef, useMemo } from "react";
import MarkDown from "@/components/MarkDown";
import Marquee from "@/components/ui/Marquee";
import { data as items } from "@/data/About";
import { useInView } from "@/hooks/useFramerMotion";
import { useScrollVelocity } from "@/hooks/useScrollVelocity";
import { useLocale } from "next-intl";
import { Locale } from "@/i18n/routing";
import { useSceneContext } from "@/contexts/SceneContext";
const AboutLove = dynamic(() => import("@/components/3D/Scenes/AboutLove"), {
  ssr: false
});
const LoveBanner = () => {
  const $ = _c(23);
  const {
    webGLAvailable
  } = useSceneContext();
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      amount: "some"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const isInView = useInView(ref, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      amount: "some",
      once: true
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasEntered = useInView(ref, t1);
  const {
    velocityFactor
  } = useScrollVelocity();
  const [hover, setHover] = useState(false);
  const locale = useLocale() as Locale;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = items.sort(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const randomizedItems = t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setHover(true);
    t4 = () => setHover(false);
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== hasEntered || $[6] !== isInView || $[7] !== webGLAvailable) {
    t5 = hasEntered && <div className="absolute left-1/2 top-0 aspect-square w-24 -translate-x-1/2 -translate-y-1/2 skew-y-3">{webGLAvailable ? <AboutLove active={isInView} /> : <span aria-hidden="true" className="flex size-full items-center justify-center text-7xl text-accent">♥</span>}</div>;
    $[5] = hasEntered;
    $[6] = isInView;
    $[7] = webGLAvailable;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute bottom-full left-0 h-[3px] w-[calc(50%-4rem)] bg-mint/40" />;
    t7 = <div className="absolute bottom-full right-0 h-[3px] w-[calc(50%-4rem)] bg-mint/40" />;
    t8 = <div className="absolute inset-x-0 top-full h-[3px] bg-mint/40" />;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
  }
  const t9 = hover ? 0.5 : 3;
  let t10;
  if ($[12] !== locale) {
    t10 = randomizedItems.map((item, index) => {
      const value = typeof item === "string" ? item : item[locale];
      return <div key={"loves-" + value + index} className="whitespace-nowrap ~px-5/12 [&_strong]:text-2xl"><MarkDown>{value}</MarkDown></div>;
    });
    $[12] = locale;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10) {
    t11 = <div className="flex">{t10}</div>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11 || $[17] !== t9 || $[18] !== velocityFactor) {
    t12 = <Marquee speed={t9} velocityFactor={velocityFactor}>{t11}</Marquee>;
    $[16] = t11;
    $[17] = t9;
    $[18] = velocityFactor;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t5) {
    t13 = <div ref={ref} className="~pt-20/36"><div onMouseEnter={t3} onMouseLeave={t4} className="relative -skew-y-3 py-8 font-secondary font-bold ~text-base/lg ~leading-[2rem]/[2.75rem] md:tracking-wider">{t5}{t6}{t7}{t8}{t12}</div></div>;
    $[20] = t12;
    $[21] = t5;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};
export default LoveBanner;
function _temp() {
  return Math.random() - 0.5;
}